// gsap使うなら↓３ついれる
// import {Bounce, Cubic} from 'gsap/EasePack';
// import TimelineMax from 'gsap/TimelineMax';
// import TweenMax from 'gsap/TweenMax';



$(function () {

	//モーダルメニュー(ナビゲーションメニュー)
	const $window = $(window),
		$html = $('html'),
		$body = $('body'),
		$overlay = $('.nav_overlay'),
		$btn_modal = $('.btn_modal_container .btn_modal'),
		scrollbar_width = window.innerWidth - document.body.scrollWidth;
	let touch_start_y;

	$window.on('touchstart', function (event) {
		touch_start_y = event.originalEvent.changedTouches[0].screenY;
	});

	$('.btn_modal_container').on('click', function () {
		$window.on('touchmove.noscroll', function (event) {
			let overlay = $overlay[0],
				current_y = event.originalEvent.changedTouches[0].screenY,
				height = $overlay.outerHeight(),
				is_top = touch_start_y <= current_y && overlay.scrollTop === 0,
				is_bottom = touch_start_y >= current_y && overlay.scrollHeight - overlay.scrollTop === height;

			if (is_top || is_bottom) {
				event.preventDefault();
			}
		});

		$('html, body').css('overflow', 'hidden');

		if (scrollbar_width) {
			$html.css('padding-right', scrollbar_width);
		}

		// $overlay.fadeIn(300);
		$overlay.addClass('overlay_show');
		$btn_modal.addClass('active');

	});

	let closeModal = function () {
		$overlay.scrollTop(0).hide().removeAttr('style');

		$body.removeAttr('style');
		$window.off('touchmove.noscroll');

		$html.removeAttr('style');
	};

	$overlay.on('click', function (event) {
		if (!$(event.target).closest('.nav_modal').length) {
			$overlay.removeClass('overlay_show');
			$btn_modal.removeClass('active');
			closeModal();
		}
	});

	$('.btn_close_modal, .btn_modal_container .btn_modal').on('click', function () {
		$overlay.removeClass('overlay_show');
		$btn_modal.removeClass('active');
		closeModal();
	});
	// -------- モーダルメニュー(ナビゲーションメニュー)


	// 3点リーダー
	const three_dots = $('.three_dots');
	let timer = false;
	three_dots.each(function () {

		let $target = $(this);
		let rest = "";

		// オリジナルの文章を取得
		let html = $target.html();

		// 対象の要素を、高さにautoを指定し非表示で複製する
		let $clone = $target.clone();
		$clone
			.css({
				display: 'none',
			})
			.width($target.width())
			.height('auto');

		// 目印クラスをつけて
		// DOMを追加
		$clone.addClass("three_dots-rest");
		$target.after($clone);

		// 指定した高さになるまで、1文字ずつ消去していく
		while ((html.length > 0) && ($clone.height() > $target.height())) {
			rest = html.substr(html.length - 1, 1) + rest;
			html = html.substr(0, html.length - 1);
			$clone.html(html + "..."); // 高さ更新
		}

		// 文章差し替え
		if (rest == "") {
			$target.html(html);
		} else {
			$target.html(html + '...');
		}
		// リサイズ用に次の要素に残りの文章を入れておく
		$clone.html(rest);
	});


	$(window).on('resize', function () {
		// タイマーによって、リサイズ単位毎に関数が実行され、重くなるのを防ぐ
		if (timer !== false) {
			clearTimeout(timer);
		}
		timer = setTimeout(function () {
			three_dots.each(function () {

				let $target = $(this);
				let rest;
				// 以前にリサイズしたか(document.readyで必ず<p class="three_dots-rest">
				// は存在するのでこの条件文はtrueを返すが、念のため)
				if ($target.next().hasClass("three_dots-rest")) {
					// 省略していた文章を取得
					rest = $target.next().html();
					// 省略していた文章が空ではなかったとき、本文には３点リーダーが表示されて
					// いるので、その３文字を削除
					if (rest != "") {
						$target.html($target.html().slice(0, -3)); // 末尾の...を削除
					}
					// これがないと永遠に<p class="three_dots-rest">が増えていく
					$target.next().remove();
				} else {
					rest = "";
				}

				// オリジナルの文章を復元
				let html = $target.html() + rest;

				// 対象の要素を、高さにautoを指定し非表示で複製する
				// 方針としては、このクローン(オリジナルの文章を保持)を非表示でブラウザに配置させ、
				// クローンの文字消去と元のボックスとの高さ比較を行うことによって、
				// クローンが元のボックスと同様の高さになったときの文章で差し替える
				let $clone = $target.clone();
				$clone.html(html);
				$clone
					.css({
						display: 'none',
					})
					.width($target.width())
					.height('auto');

				// 目印クラスをつけて
				// DOMを追加 (これにより高さを獲得)
				$clone.addClass("three_dots-rest");
				$target.after($clone);

				rest = "";
				// 指定した高さになるまで、1文字ずつ消去していくと同時に、
				// 文章が完全消去されないように rest に退避させておく
				while ((html.length > 0) && ($clone.height() > $target.height())) {
					rest = html.substr(html.length - 1, 1) + rest;
					html = html.substr(0, html.length - 1);
					$clone.html(html + "..."); // 高さ更新
				}

				// 文章差し替え
				// rest が空っぽということは、三点リーダーを表示する必要がないということ
				if (rest == "") {
					$target.html(html);
				} else {
					$target.html(html + '...');
				}
				// 次のリサイズ用に次の要素に残りの文章を入れておく
				$clone.html(rest);
			});
		}, 200);
	});
	// -------- 三点リーダー

});




